var _rect, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#18162C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "loader_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h12v12H6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#loader_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7a5 5 0 0 1 4.095 7.87L14.5 12H16a4 4 0 0 0-6.77-2.886l-.499-.897A4.98 4.98 0 0 1 12 7Zm0 10a5 5 0 0 1-4.095-7.87L9.5 12H8a4 4 0 0 0 6.77 2.886l.498.898A4.98 4.98 0 0 1 12 17Z",
    fill: "#fff"
  }))));
};

export default SvgLoader;